/*
 * Experimental flux implementation based on redux patters
 */

import {
  setState,
  getState,
  reduceAction,
  stateChangedFor,
  stateMap,
} from './state';

import { getListeners } from './listeners';

export function dispatch(action) {
  const prevState = getState();
  const changedCache = {};
  const nextState = reduceAction(action);

  setState(nextState);

  const listeners = getListeners();
  for (const index in listeners) {
    const { interests, handler } = listeners[index];

    if (stateChangedFor(interests, prevState, changedCache)) {
      handler.call(null, stateMap(interests));
    }
  }

  window.lastChanged = changedCache;
}

export { registerStores, setState, getState } from './state';
export { connect } from './wrapper';
export { addListener, removeListener } from './listeners';
